import validate from "/private/tmp/nix-build-festival-manager-0.0.1.drv-0/incl/node_modules/.pnpm/nuxt@3.8.2_@types+node@18.19.3_eslint@8.55.0_rollup@2.79.1_sass@1.69.5_typescript@5.3.3_vite@4.5.1/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/private/tmp/nix-build-festival-manager-0.0.1.drv-0/incl/node_modules/.pnpm/nuxt@3.8.2_@types+node@18.19.3_eslint@8.55.0_rollup@2.79.1_sass@1.69.5_typescript@5.3.3_vite@4.5.1/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/private/tmp/nix-build-festival-manager-0.0.1.drv-0/incl/middleware/auth.ts"),
  "open-feature": () => import("/private/tmp/nix-build-festival-manager-0.0.1.drv-0/incl/middleware/openFeature.ts")
}